export default "__VITE_ASSET__BywV1Y3Y__"